module.exports = __webpack_public_path__ + "img/Katarina_acc_04.a490f715.jpg";